import React, { useEffect, useState } from "react";


import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.scss";
import GreeceSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";
import * as localLang from "../../../i18n/i18n";
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const randomBg = bgSliders.getRandomBg();
function GreeceSignupPage({ t }) {


  const [errorMesg, setErrorMesg] = useState(false);

  const [agree, setagree] = useState(true);
  const [showterms, setshowterms] = useState(true);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");

  const [showLoading, setshowLoading] = useState(false);

  const [phonenumber, setphonenumber] = useState("");

  const history = useHistory();
  const [alert, setAlert] = useState(false);




  useEffect(() => {


    const params = queryString.parse(window.location.search);
    if (params.lang) {
      localStorage.setItem("i18nextLng", params.lang);
      if (localStorage.getItem("i18nextLng") != params.lang) {
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }

    }



    const urlsearch = window.location.search;
    if (urlsearch !== "") {
      //console.log("tracker")
      setAgencyData(urlsearch);
    }
  }, []);












  const subscribeHe = async e => {
    e.preventDefault();

    axios.get(`https://vas2.grand-hub.com/api/PlayIt/gr-dot-d/he`)
      .then(res => {
        setshowLoading(false);
        if(res.data.success){
            window.location.href=res.data.url
        }
      })
      .catch(function (error) {
       setErrorMesg(true);
       setErrorMesgSubscribe(error.error.message)

      })
      .finally(function () {

      });



  };



  return (
    <GreeceSignupPageDisplay className="">
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

     

      <div className='operatorSignup'>
        <div className="formsLayout formsLayoutjawal">

          <div className='header header_gamezone'>
            <Link to="/">
              <div className='logo logo gamezoneLogo' />
            </Link>
          </div>
        
            <div className="links-Section links-Sectionjawwalgamezorid">


              <div className="play"></div>

              <form name="formsubmit" onSubmit={(e) => { e.preventDefault(); subscribeHe(e); }}>



                <br /><br /><br />
                <button
                  id="signupbut"
                  className="btn"
                  disabled={agree == true ? "" : "disabled"}

                  type="submit"

                >
                  {t("subscribe")}
                </button>
              </form>

              <div className="ncellTos jawwalgamezoridncellTos mondiancellTos">
                {showterms ?
                  <h4>
                    <input type="checkbox" style={{ margin: '4px 9px 0' }} onChange={(e) => { setagree(!agree) }} checked={agree} />
                    <Trans>mondia_conditions.accept_condition</Trans></h4>
                  : ""}

              </div>

              <div className="row text-center" >
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>98%</span><img src="/assets/images/subscribegamezriod/like.png" alt="img" className="iconsimg" />
                    <p><Trans>evaluation</Trans></p>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>1000+</span><img src="/assets/images/subscribegamezriod/Repeat.png" alt="img" className="iconsimg" />
                    <p><Trans>game</Trans></p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-4 px-5">
                  <div className="games-info jawwalgames-info">
                    <span>500k+</span><img src="/assets/images/subscribegamezriod/group.png" alt="img" className="iconsimg" />
                    <p><Trans>user</Trans></p>
                  </div>
                </div>
              </div>


              <div className="footer jawwalgamezoridFooter zainiqFooter">
                <div className="ncellTos jawwalgamezoridncellTos">
                  <p style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}><Trans>trendy-condtion_tandc1</Trans></p>
                  <p style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}><Trans>GreeceCondition</Trans></p>
                  <p style={{ lineHeight: "1.2", margin: "0 0 5px 0" }}><Trans>trendy-condtion_tandc6</Trans></p>

                </div>
              </div>
            </div>

         



          {showLoading ?
            <div className="load">
              <div className="spinerC">
                <div className="spinner"></div>
              </div>
            </div>
            : null}




        </div>
      </div>



    </GreeceSignupPageDisplay>
  );
}
export default withTranslation()(GreeceSignupPage)
